import { memo } from "react";

const LogoIcon = () => {
  return (
    <svg
      style={{ width: "auto" }}
      viewBox="0 0 120 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M61.4609 117.539C93.7912 117.539 120 91.3303 120 58.9999C120 26.6696 93.7912 0.460693 61.4609 0.460693C29.1306 0.460693 2.92163 26.6696 2.92163 58.9999C2.92163 91.3303 29.1306 117.539 61.4609 117.539Z"
        fill="#FFBC00"
      />
      <path d="M98.1984 24.0881H0V93.3638H98.1984V24.0881Z" fill="#0D2772" />
      <path
        d="M40.6453 45.2691V72.1833L66.7195 58.7445L40.6453 45.2691Z"
        fill="white"
      />
    </svg>
  );
};

export default memo(LogoIcon);
